import angular from 'angular';
import gradientBanner from './gradientBanner';

export default angular
  .module('components.gradientBanner', [])
  .component('gradientBanner', gradientBanner).name;
